import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=84dd0c58&scoped=true&ts=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=ts"

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=84dd0c58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84dd0c58"]])

export default __exports__